






































































































































































import { setCssThemeVars, setCheckoutTheme, checkForSavedConfigs, saveToLocalStorage } from '@/utils/gamblingHelpers'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Action, Mutation } from 'vuex-class'
import { mapState } from 'vuex'

@Component({
  computed: {
    ...mapState({
      config: ({ cashierContext }: any) => cashierContext.config,
      autoProcessProviderState: ({ cashierContext }: any): string => cashierContext.autoProcessProvider,
      themeOptionsState: ({ gamblingContext }: any): string[] => gamblingContext.themeOptions,
      cashierSpinner: ({ cashierContext }: any): object => cashierContext.cashierSpinner,
      choosedTheme: ({ gamblingContext }: any): string[] => gamblingContext.choosedTheme,
      pageLayoutOptions: ({ gamblingContext }: any) => gamblingContext.pageLayoutOptions,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout,
      customCss: ({ cashierContext }: any): string => cashierContext.customCss,
      cashierTypeState: ({ cashierContext }: any): string => cashierContext.cashierType,
      checkoutClient: ({ cashierContext }: any): boolean => cashierContext.checkoutClient
    })
  }
})
export default class Account extends Vue {
  @Action('reloadCashier') reloadCashier: any
  @Action('setCurrency') setCurrency: any
  @Action('setPageTheme') setPageTheme: any
  @Mutation('setAutoProcessProvider') setAutoProcessProvider: any
  @Mutation('setCashierSpinner') setCashierSpinner: any
  @Mutation('setPageLayout') setPageLayout: any
  @Mutation('setCashierType') setCashierType: any
  @Mutation('setCheckoutClient') setCheckoutClient: any

  @Prop({ type: String, required: true }) fullname!: string
  @Prop({ type: String, required: true }) email!: string

  choosedTheme!: string
  themeOptionsState!: string[]
  themeOptions!: string[]
  checkoutBg: string = 'light'
  checkoutClient!: boolean
  accountConfigClone: any = {
    userId: '',
    merchantId: '',
    sessionId: '',
    autoProcessProvider: '',
    environment: ''
  }
  config!: any
  userId: string = ''
  merchantId: string = ''
  sessionId: string = ''
  environment: string = ''
  autoProcessProvider: string = ''
  autoProcessProviderState!: string
  cashierSpinner!: string
  pageLayout!: string
  pageLayoutOptions!: string[]
  customCss!: string
  typeOfCashiers: string[] = [
    'Standard flow',
    'Single Page Flow',
    'Cards'
  ]
  $cashierConfigs!: any
  cashierTypeState!: string
  authorizedUsers: string[] = [
    'Håkan Sundström',
    'Ian Bradbury',
    'Olivia Englund',
    'Christer Wikman',
    'Simon Solders'
  ]

  @Watch('cashierType')
  onCashierType (val: string, preVal: string) {
    this.cashierType = val
    this.saveToLocalStorage()
    this.$cashierConfigs('dynamicCashierType')
  }

  @Watch('checkoutBg')
  onCheckoutBg (val: string) {
    setCheckoutTheme(val)
    this.saveToLocalStorage()
  }

  get getSetCheckoutClient () {
    return this.checkoutClient
  }

  set getSetCheckoutClient (val: boolean) {
    this.setCheckoutClient(val)
  }

  get cashierType () {
    return this.cashierTypeState
  }
  set cashierType (val: string) {
    this.setCashierType(val)
  }

  get getSetPageLayout () {
    return this.pageLayout
  }
  set getSetPageLayout (layout: string) {
    this.setPageLayout(layout)
    this.saveToLocalStorage()
  }

  get choosedThemeGetSet () {
    return this.choosedTheme
  }
  set choosedThemeGetSet (themeColor: string) {
    this.setPageTheme(themeColor)
  }

  get authorizeUser (): boolean {
    const authorizedUsers = this.authorizedUsers
    return !authorizedUsers.some((val: string) => {
      const firstAndSecondName = []
      const splitted = val.toLowerCase().split(' ')
      const fullname = this.fullname.toLowerCase()
      splitted.forEach((name: string) => {
        if (fullname.includes(name)) {
          firstAndSecondName.push(name)
        }
      })
      return firstAndSecondName.length >= 2
    })
  }

  get saveConfigBtn (): boolean {
    return this.userId === this.accountConfigClone.userId &&
      this.merchantId === this.accountConfigClone.merchantId &&
      this.sessionId === this.accountConfigClone.sessionId &&
      this.autoProcessProvider === this.accountConfigClone.autoProcessProvider &&
      this.environment === this.accountConfigClone.environment
  }

  setSpinner (val: string): void {
    this.setCashierSpinner(val)
    this.saveToLocalStorage()
  }

  updateTheme (theme: string): void {
    setCssThemeVars(theme)
    this.saveToLocalStorage()
  }

  saveConfigs (): void {
    this.reloadCashier({
      userId: this.userId,
      merchantId: this.merchantId,
      sessionId: this.sessionId,
      environment: this.environment
    })
    this.setAutoProcessProvider(this.autoProcessProvider)
    this.setCurrency()
    this.setConfigClone()
    this.$cashierConfigs('updateLatest')
  }

  setConfigClone () {
    this.accountConfigClone.userId = this.config.userId
    this.accountConfigClone.merchantId = this.config.merchantId
    this.accountConfigClone.sessionId = this.config.sessionId
    this.accountConfigClone.autoProcessProvider = this.autoProcessProvider
    this.accountConfigClone.environment = this.config.environment
    this.saveToLocalStorage()
  }

  saveToLocalStorage (): void {
    const newConfigsToSave = {
      ...this.accountConfigClone,
      demoThemesOptions: {
        theme: this.choosedThemeGetSet || 'yellow',
        checkoutBg: this.checkoutBg,
        spinner: this.cashierSpinner,
        pageLayout: this.pageLayout,
        dynamicCashierType: this.cashierType
      }
    }
    saveToLocalStorage(newConfigsToSave)
    this.$cashierConfigs('updateLatest')
  }

  private created (): void {
    this.themeOptions = [ ...this.themeOptionsState ]
    this.userId = this.config.userId
    this.merchantId = this.config.merchantId
    this.sessionId = this.config.sessionId
    this.environment = this.config.environment
    this.autoProcessProvider = this.autoProcessProviderState
    this.setConfigClone()
    const theme = document.querySelector('#gambling-checkout-vars')
    const darkTheme = theme && theme.innerHTML.includes('checkout-theme:dark')
    if (darkTheme) {
      this.checkoutBg = 'dark'
    } else {
      this.checkoutBg = 'light'
    }
  }
}
